import { TipoDeRecurso } from '@/models/Recurso';
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds';
import { RouteConfig } from 'vue-router';

const rotas: RouteConfig[] = [
	{
		path: 'grupos-economicos',
		name: 'Grupos Econômicos',
		components: {
			default: () =>
				import('@/views/application/lojas/TelaDeGrupoEconomico.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
		meta: {
			recurso: 'grupos-economicos' as TipoDeRecurso,
		},
	},
]

export default rotas